const SystemHelpTopics = () => import('Views/system/help-topics');
const SystemHelpArticles = () => import('Views/system/help-articles');
const HelpCenter = () => import('Views/help-center/index');
const HelpDetail = () => import('Views/help-center/help-detail');

export default[
  { path: '/system/help-topics', component: SystemHelpTopics },
  { path: '/system/help-articles', component: SystemHelpArticles },
  { path: '/help-center', component: HelpCenter },
  { path: '/help-detail', component: HelpDetail },
];



// WEBPACK FOOTER //
// ./src/router/helpCenter.js